export enum BidPackState {
  Active = 0,
  Pending = 1,
  Expired = 2,
  New = 3,
}

export enum BidPackStateStringValue {
  Active = "Active",
  Pending = "Pending",
  Expired = "Expired",
  New = "New",
}

export const bidPackStateAsStringFirstLetter = new Map([
  [BidPackState.Active, "A"],
  [BidPackState.Pending, "P"],
  [BidPackState.Expired, "E"],
  [BidPackState.New, "N"],
]);
